exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loader p[data-v-0a1e71b8] {\n\tmargin: 0;\n\tfont-size: 1.2em;\n}\n.card .card-header[data-v-0a1e71b8] {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 15px 10px 20px 28px;\n}\n", ""]);

// exports
